/*
 * EmailJS Configuration
 *
 * To set up email functionality:
 * 1. Create an account at https://www.emailjs.com/
 * 2. Add an email service (Gmail, Outlook, etc.)
 * 3. Create an email template
 * 4. Replace the values below with your actual EmailJS credentials
 */

export const EMAILJS_CONFIG = {
  SERVICE_ID: 'service_52x873j', // Your Gmail service ID
  TEMPLATE_ID: 'template_bodolfm', // Replace with your EmailJS template ID
  PUBLIC_KEY: 'fbJfldUb7yXNA3Ufi', // Replace with your EmailJS public key
};

/*
 * Email Template Variables:
 * Use these variables in your EmailJS email template:
 *
 * {{from_name}} - Sender's name
 * {{from_phone}} - Sender's phone number
 * {{from_email}} - Sender's email address
 * {{message}} - Message content
 * {{to_name}} - Recipient name (will be "Nakshatra Infra Team")
 *
 * Example EmailJS Template:
 *
 * Subject: New Contact Form Submission from {{from_name}}
 *
 * Dear {{to_name}},
 *
 * You have received a new contact form submission:
 *
 * Name: {{from_name}}
 * Phone: {{from_phone}}
 * Email: {{from_email}}
 *
 * Message:
 * {{message}}
 *
 * Best regards,
 * Nakshatra Infra Contact System
 */